import { FC, Suspense } from 'react';
import { DiscoverCampaignSection } from './campaign';
import { DiscoverInfoSection } from './info';
import { DiscoverUserSection } from './user';
import { DiscoverTopicSection } from './topic';
import { DiscoverBreadcrumbs } from './breadcrumbs/index';
import { DiscoverBodySkeleton } from '~/skeleton/discover';
import { DiscoverImmersivePostSection } from '@discover/body/immersive-post';
import { KEPSilentAwaken } from './kep-silent-awaken';

import './style.scss';

export const DiscoverBody: FC = () => {
  return (
    <>
      <KEPSilentAwaken />
      <DiscoverBreadcrumbs />
      <Suspense fallback={<DiscoverBodySkeleton />}>
        <DiscoverInfoSection />
        <DiscoverImmersivePostSection />
        <DiscoverUserSection />
        <DiscoverTopicSection />
        <DiscoverCampaignSection />
      </Suspense>
    </>
  );
};
